import UserAvatar from "Areas/SharedFeatures/userAvatar";
import { ACCESS_LEVEL_ACCESS, accessLevelAccessLocale } from "Common/dictionaries/accessLevelAccess";
import Button from "Components/button";
import ScrolledDropdown from "Components/scrolledDropdown";
import classNames from "classnames";
import cloneDeep from "lodash/cloneDeep";
import keyBy from "lodash/keyBy";
import map from "lodash/map";
import reject from "lodash/reject";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { accessIdKeySelector, accessIdTextSelector, accessOnTextSelector } from "../utils/selectors";
import locale from "./accessLevelsEditor.locale";
import Styled, { SIZES } from "./accessLevelsEditor.styled";
export default function AccessLevelsEditor(props) {
    const [draft, setDraft] = useState({});
    const [hasChanges, setHasChanges] = useState(false);
    const accessItems = useMemo(() => map(ACCESS_LEVEL_ACCESS, a => ({
        Id: a,
        Name: accessLevelAccessLocale[a]
    })), []);
    useEffect(() => {
        props.accessLevelsKey && setDraft(cloneDeep(props.data || {}));
        setHasChanges(false);
    }, [props.data, props.accessLevelsKey]);
    const usersByKey = useMemo(() => props.users && keyBy(props.users, "Id"), [props.users]);
    const handleCancel = useCallback(() => {
        setDraft(cloneDeep(props.data || {}));
        setHasChanges(false);
    }, [props.data]);
    const handleDelete = useCallback((accessLevel) => () => {
        draft[accessLevel.UserId].Deleted = !draft[accessLevel.UserId].Deleted;
        draft[accessLevel.UserId].Changed = true;
        setDraft(cloneDeep(draft));
        setHasChanges(true);
    }, [draft]);
    const handleAccessLevelChanged = useCallback((accessLevel) => (access) => {
        draft[accessLevel.UserId].Access = access;
        draft[accessLevel.UserId].Changed = true;
        setDraft(cloneDeep(draft));
        setHasChanges(true);
    }, [draft]);
    const handleSave = useCallback(() => {
        if (props.onSave) {
            props.onSave(draft);
        }
    }, [draft, props.onSave]);
    return (React.createElement("div", { className: classNames("flex-single-column", props.className) },
        React.createElement("div", { className: "flex-greedy-block d-flex-column with-gap-20" }, map(reject(draft, "Deleted"), accessLevel => {
            var _a;
            let userDelete = false;
            let user = usersByKey && usersByKey[accessLevel.UserId];
            if (user === undefined && accessLevel.UserId === ((_a = props.userCreate) === null || _a === void 0 ? void 0 : _a.Id)) {
                userDelete = true;
                user = props.userCreate;
            }
            return (React.createElement("div", { key: accessLevel.UserId, className: "flex-space-between" },
                React.createElement("div", { className: "d-flex v-center-items" },
                    user ? (React.createElement(UserAvatar, { size: SIZES.AVATAR_SIZE, userId: user.Id, login: user.Login, fullName: user.FullName, isParticipant: true })) : (React.createElement(Styled.EmptyAvatar, null)),
                    React.createElement(Styled.Name, null,
                        React.createElement("div", { className: "text-overflow-ellipsis nowrap text-light-on-background" }, user === null || user === void 0 ? void 0 : user.FullName),
                        props.selfUserId === (user === null || user === void 0 ? void 0 : user.Id) && (React.createElement("span", { className: "ml-xxxs text-primary-500" },
                            "(",
                            locale.YOU,
                            ")")),
                        userDelete && (React.createElement("span", { className: "ml-xxxs text-danger-500" },
                            "(",
                            locale.USER_DELETED,
                            ")")))),
                React.createElement("div", { className: "flex-space-between h-right-content w-100" },
                    React.createElement(ScrolledDropdown, { items: accessItems, disabled: props.selfUserId === (user === null || user === void 0 ? void 0 : user.Id) ||
                            accessLevel.Access === ACCESS_LEVEL_ACCESS.CREATOR, keySelector: accessIdKeySelector, textSelector: accessIdTextSelector, visibilitySelector: accessOnTextSelector, onSelectedChanged: handleAccessLevelChanged(accessLevel), selectedKey: accessLevel.Access, className: "dropdown-toggle-flex-space-between", maxWidth: "100%", togglerClassName: "border-rounded-medium p-4-0", togglerHeight: 36 }),
                    React.createElement(Button, { className: "no-border no-default-colors", disabled: props.selfUserId === (user === null || user === void 0 ? void 0 : user.Id) ||
                            accessLevel.Access === ACCESS_LEVEL_ACCESS.CREATOR, onClick: handleDelete(accessLevel) },
                        React.createElement("i", { className: "icon-trash text-danger-500" })))));
        })),
        React.createElement("div", { className: "d-flex justify-content-flex-end with-gap-8 mt-24" },
            React.createElement(Button, { className: "btn-h-m p-8-24", text: locale.CANCEL, onClick: handleCancel, disabled: !hasChanges }),
            React.createElement(Button, { text: locale.SAVE, className: "btn-primary btn-h-m p-8-24", disabled: !hasChanges, onClick: handleSave }))));
}
